// Ordered walkthrough shown to admins: starts on the Rules page and carries
// through to the Stage Quiz (themeupdate) page. `page` must match the value
// each page passes to useAdminTour, and `selector` must match a data-tour
// attribute rendered on that page.
export const TOUR_ROUTES = {
  rules: "/admin/rules",
  stagequiz: "/admin/themeupdate",
};

export const TOUR_STEPS = [
  {
    page: "rules",
    selector: '[data-tour="rules-thankyou"]',
    title: "Thank You Message",
    text: "Add the text shown to players on the Thank You page after they finish the quiz.",
  },
  {
    page: "rules",
    selector: '[data-tour="rules-rules-list"]',
    title: "Game Rules",
    text: "Add up to 6 rules here — they show up in the in-game Rules (?) popup that players can open any time.",
  },
  {
    page: "rules",
    selector: '[data-tour="rules-points"]',
    title: "Points",
    text: "Set how many points a player earns for each correct answer.",
  },
  {
    page: "rules",
    selector: '[data-tour="rules-colors"]',
    title: "Colors",
    text: "Choose the Button color, Button text color and Text color — these apply everywhere in the game: buttons, badges, arrows and text.",
  },
  {
    page: "rules",
    selector: '[data-tour="rules-tabname"]',
    title: "Tab Name",
    text: "Give this theme a short browser tab name.",
  },
  {
    page: "rules",
    selector: '[data-tour="rules-save"]',
    title: "Save & Continue",
    text: "Click Save, then Next below to set up this theme's 5 quiz stages.",
  },
  {
    page: "stagequiz",
    selector: '[data-tour="stagequiz-tabs"]',
    title: "Stages",
    text: "Every theme has exactly 5 stages. Click a tab to switch between them.",
  },
  {
    page: "stagequiz",
    selector: '[data-tour="stagequiz-title"]',
    title: "Stage Title",
    text: "Give this stage a title — it's shown to players on this stage's screen.",
  },
  {
    page: "stagequiz",
    selector: '[data-tour="stagequiz-heading"]',
    title: "Question Heading",
    text: "Add a short heading shown above this stage's questions.",
  },
  {
    page: "stagequiz",
    selector: '[data-tour="stagequiz-type"]',
    title: "Question Type",
    text: "Pick this stage's format — image + audio, GIF, image, or text-only. The fields below change to match.",
  },
  {
    page: "stagequiz",
    selector: '[data-tour="stagequiz-questions"]',
    title: "Questions",
    text: "Upload the required media, fill in the options, and mark the correct answer for each question.",
  },
  {
    page: "stagequiz",
    selector: '[data-tour="stagequiz-save"]',
    title: "Update",
    text: "Click Update to save this stage. That's the full walkthrough — happy editing!",
  },
];
